import { ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const softwarePlanSettingsExclusionRulesRoute: InvariantRoute = {
	name: ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES,
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/exclusion-rules',
};
